<template>
  <div class="menubtn">
    <template v-if="this.$i18n.locale === 'zh'">
      <router-link
        :to="{ path: '/menu/', params: { lang: this.$i18n.locale } }"
      >
        <el-button size="medium" type="success">{{
          $t("message.wedding.banner.btn")
        }}</el-button>
      </router-link>
    </template>
    <template v-else>
      <router-link
        :to="{ path: '/en/menu/', params: { lang: this.$i18n.locale } }"
      >
        <el-button size="medium" type="success">{{
          $t("message.wedding.banner.btn")
        }}</el-button>
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: "menubtn",
  data() {
    return {};
  }
};
</script>

<style>
.menubtn {
  width: 20rem;
  margin: 5% auto 0 auto;
}
.menubtn span {
  width: 100%;
  display: block;
}
.menubtn a {
  width: 100%;
  display: block;
  color: white;
  text-decoration: none;
}
@media (max-width: 480px) {
  .menubtn {
    width: 10rem;
    margin: 5% auto;
  }
}
</style>
